import React from 'react';
import { Paper, List, ListItem, Typography } from '@mui/material';

function DeleteAccountInstructions() {
    return (
        <Paper
            elevation={0}
            sx={{ p: 2, height: '100vh' }}>
            <Typography
                variant="h4" component="h1" sx={{ mb: 2 }}>
                How to Delete Your Account and Data ?
            </Typography>
            <List>
                <ListItem>
                    <Typography>
                        Go to your profile in the app.
                    </Typography>
                </ListItem>
                <ListItem>
                    <Typography>
                        Click on the "Delete my account" button.
                    </Typography>
                </ListItem>
            </List>
        </Paper>
    );
}

export default DeleteAccountInstructions;
